<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('history.Header') }}</h2>
                {{ $t('history.HeaderText') }}
                <br />
                <h3>{{ $t('history.Subheader1') }}</h3>
                {{ $t('history.SubheaderText1') }}
                <br />
                <h3>{{ $t('history.Subheader2') }}</h3>
                {{ $t('history.SubheaderText2') }}
                <br />
                <h3>{{ $t('history.Subheader3') }}</h3>
                {{ $t('history.SubheaderText3a') }}
                <br />
                <br />
                {{ $t('history.SubheaderText3b') }}
                <br />
                <br />
                {{ $t('history.SubheaderText3c') }}
                <br />
                <br />
                {{ $t('history.SubheaderText3d') }}
                <br />
                <br />
                {{ $t('history.SubheaderText3e') }}
                <br />
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import { EventBus } from '@/classes/eventBus.js';

    export default {
        props: {
            linkItem: String,
            myText: String
        },
        data: function () {
            return {
                theImage: '',
            }
        },
        computed: {
        },
        mounted() {
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
        },
        methods: {
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>